export default function Status(status: string) {
  status = status.toLocaleLowerCase();
  const statusClass = () => {
    if (["accepted", "pending"].includes(status))
      return "rounded-2xl bg-orange-400 text-white w-24 text-center capitalize";
    else if (status === "started")
      return "rounded-2xl bg-green-400 text-white w-24 text-center capitalize";
    else if (["cancelled", "canceled"].includes(status))
      return "rounded-2xl bg-red-500 text-white w-24 text-center capitalize";
    else if (status === "declined")
      return "rounded-2xl bg-purple-500 text-white w-24 text-center capitalize";
    else
      return "rounded-2xl bg-gray-400 text-white w-24 text-center capitalize";
  };

  return (
    <p
      style={{ paddingBottom: "2px", fontSize: "13px" }}
      className={statusClass()}
    >
      {status}
    </p>
  );
}
